import { render, staticRenderFns } from "./OnlineOrderDocs.vue?vue&type=template&id=8f219078&"
import script from "./OnlineOrderDocs.vue?vue&type=script&lang=js&"
export * from "./OnlineOrderDocs.vue?vue&type=script&lang=js&"
import style0 from "./OnlineOrderDocs.vue?vue&type=style&index=0&id=8f219078&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports